import { render, staticRenderFns } from "./articleDetails.vue?vue&type=template&id=6c47ae54&scoped=true"
import script from "./articleDetails.vue?vue&type=script&lang=js"
export * from "./articleDetails.vue?vue&type=script&lang=js"
import style0 from "./articleDetails.vue?vue&type=style&index=0&id=6c47ae54&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c47ae54",
  null
  
)

export default component.exports